import React from 'react'
import LeaveApplication from '../Components/LeaveManagement/LeaveApplication/LeaveApplication'
// import LeaveApplicationList from '../Components/LeaveManagement/LeaveApplication/LeaveApplicationList'

const LeaveApplicationPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      <LeaveApplication/>
    </div>
  )
}

export default LeaveApplicationPage
